import { Button, Stack, Typography } from '@mui/material';
import { Add as PlusIcon } from '@mui/icons-material';
import useNavigate from '../../../hooks/useNavigate';
import { Wrapper } from './NoAccountFound.styled';

export const NoAccountFound = ({ userEmail }:{userEmail:string}):JSX.Element => {
  const { goToCreateAccount } = useNavigate();
    
  return (
    <Wrapper>
      <Stack>
        <Typography variant="h4" textAlign="center">
          No accounts found
        </Typography>

        <Typography variant="h6" textAlign="center">
          {'You\'re good to go'}
        </Typography>
      </Stack>

      <Button variant="contained"
        startIcon={ <PlusIcon /> }
        sx={ { alignSelf: 'flex-end' } }
        onClick={ () => goToCreateAccount(userEmail) }
      >Create new account
      </Button>
    </Wrapper>
  );
};
